import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { CodeType } from '../../staff/models/accounts.model';

// Rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Services
import { HttpService } from '../../core/services/http.service';

// Base URL
import { BASE_URL } from '../../core/services/api';

// Interfaces
import { Account } from '../interfaces/account.interface';
import { Phone, Phone2FA } from '../interfaces/phone.interface';
import { LANGUAGES } from '../../translation/translation';

@Injectable()
export class AccountService {

  // Base URL
  private PATH: string = BASE_URL + 'client/';

  // Constructor
  constructor(private http: HttpService) { }

  // Check Email
  public emailVerification(email: { email: string }): Observable<Response> {
    return this.http.post(this.PATH + 'client/email-verification', email);
  }

  // Update Client Account
  public updateClientAccount(account: Account): Observable<Response> {
    return this.http.post(this.PATH + 'client/update-client-account', account);
  }

  // Update Client Phone Number
  public updateClientPhone(phone: Phone): Observable<Response> {
    return this.http.post(this.PATH + 'client/change-phone', phone);
  }

  // Update Client Phone Number 2FA
  public updateClientPhone2FA(phone: Phone2FA): Observable<Response> {
    return this.http.post(this.PATH + 'client/change-phone-with-factor', phone);
  }

  // 2FA Phone Verification Call
  public tfaPhoneCall(phone: Phone): Observable<Response> {
    return this.http.post(this.PATH + 'client/call-to-phone', phone);
  }

  // Update Client 2FA Configuration
  public update2FAConfiguration(status): Observable<Response> {
    return this.http.post(this.PATH + 'client/client-account-security', status);
  }

  // Verify Client 2FA Configuration
  public verify2FAConfiguration(tfaCode: string, tfaType: CodeType): Observable<Response> {
    console.log('account.service.ts:verify2FAConfiguration  tfaCode=', tfaCode, '  tfaType=', tfaType);
    return this.http.post(this.PATH + 'client/tfa-verification', {tfaCode, tfaType});
  }

  // Change Client Password
  public changeClientPassword(values): Observable<Response> {
    return this.http.post(this.PATH + 'client/client-change-password', values);
  }

  // License Agreement
  public licenseAgreement(status): Observable<Response> {
    return this.http.post(this.PATH + 'client/accept-eula', {status: status});
  }

  // Get License Agreement
  public getLicenseAgreement(lan_code): Observable<Response> {
    if (!lan_code) {
      lan_code = LANGUAGES[0].code;
    }
    return this.http.post(BASE_URL + 'license/license/get-license-agreement', { lan_code: lan_code });
  }

  // Get Privacy
  public getPrivacy(lan_code): Observable<Response> {
    if (!lan_code) {
      lan_code = LANGUAGES[0].code;
    }
    return this.http.post(BASE_URL + 'support/support/get-privacy-landing', { lan_code: lan_code });
  }

  // Get Terms
  public getTerms(lan_code): Observable<Response> {
    if (!lan_code) {
      lan_code = LANGUAGES[0].code;
    }
    return this.http.post(BASE_URL + 'support/support/get-terms-landing', { lan_code: lan_code });
  }

  // Send Validation Code To Email Address
  public sendCodeToEmailAddress(email): Observable<Response> {
    return this.http.post(this.PATH + 'client/send-email-code', email);
  }

  // Validate Email Address
  public validateEmailAddress(email: string, email_code: string): Observable<Response> {
    return this.http.post(this.PATH + 'client/change-email-with-code', { email, email_code });
  }

  // Get Client Projects
  public getClientProjects(): Observable<Response> {
    return this.http.get(BASE_URL + 'project/project/get-projects-list');
  }

}



// WEBPACK FOOTER //
// ./src/app/my-account/services/account.service.ts